var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "childOutbound-wrap" },
    [
      _c(
        "el-descriptions",
        {
          staticClass: "child-outbound-description",
          attrs: {
            border: "",
            title: "客户：" + _vm.list.company,
            column: _vm.getIsMobile ? 1 : 3,
          },
        },
        [
          _c("el-descriptions-item", { attrs: { label: "商品编码" } }, [
            _vm._v(_vm._s(_vm.list.id)),
          ]),
          _c("el-descriptions-item", { attrs: { label: "品牌" } }, [
            _vm._v(_vm._s(_vm.list.source)),
          ]),
          _c("el-descriptions-item", { attrs: { label: "型号" } }, [
            _vm._v(_vm._s(_vm.list.xhname)),
          ]),
          _c("el-descriptions-item", { attrs: { label: "进货（未税）价格" } }, [
            _vm._v(_vm._s(_vm.list.wshui)),
          ]),
          _c("el-descriptions-item", { attrs: { label: "进货（含税）价格" } }, [
            _vm._v(_vm._s(_vm.list.hshui)),
          ]),
          _c("el-descriptions-item", { attrs: { label: "是否含税" } }, [
            _vm._v(_vm._s(_vm.list.sfkp == "2" ? "未税" : "含税")),
          ]),
          _c(
            "el-descriptions-item",
            { attrs: { label: "最终价格", labelStyle: { color: "red" } } },
            [_vm._v(_vm._s(_vm.list.price))]
          ),
          _c("el-descriptions-item", { attrs: { label: "进货日期" } }, [
            _vm._v(_vm._s(_vm.list.settime)),
          ]),
          _c("el-descriptions-item", { attrs: { label: "收票状态" } }, [
            _vm._v(
              _vm._s(
                _vm.list.sfsp == "0"
                  ? "未税"
                  : _vm.list.sfsp == "1"
                  ? "已到"
                  : "未到"
              )
            ),
          ]),
          _c("el-descriptions-item", { attrs: { label: "供应商" } }, [
            _vm._v(_vm._s(_vm.list.gongyingshang)),
          ]),
          _c(
            "el-descriptions-item",
            { attrs: { label: "总价" } },
            [
              _c("span", { staticStyle: { color: "red" } }, [
                _vm._v(_vm._s(_vm.totalPrice)),
              ]),
              _c("el-input", {
                staticClass: "child-outbound-input",
                staticStyle: { width: "40%" },
                attrs: { size: "mini", placeholder: "请输入出库数量" },
                on: { input: _vm.handleBlur },
                model: {
                  value: _vm.num,
                  callback: function ($$v) {
                    _vm.num = $$v
                  },
                  expression: "num",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.handleClose } }, [
            _vm._v("取 消"),
          ]),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.submitLoading },
              on: { click: _vm.handleOutbound },
            },
            [_vm._v("出 库")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }